export enum PersonTypes {
  systemUser = 1,
  contact = 2,
}
